<template>
  <div class="search">
    <Spin v-if="loading" fix size="large"></Spin>
    <div class="steps">
      <Steps :current="current">
        <Step
          v-for="(s, index) in steps"
          :key="s.name"
          :title="s.text"
          @click.native="() => handleStepChange(index)"
        ></Step>
      </Steps>
    </div>
    <keep-alive>
      <component
        :is="componentName"
        :readonly="readonly"
        :modify="modify"
        :data="data"
        @on-selection="handGetSelection"
        @on-params="handGetParams"
        @on-files="handGetFiles"
        @on-prev="() => { this.current-- }"
        @on-next="() => { this.current++ }"
        @on-submit="handleSubmit"
      />
    </keep-alive>
  </div>
</template>

<script>
import Step1 from './step-1'
import Step2 from './step-2'
import Step3 from './step-3'
import { formatDate } from '@libs/tools'
import { PostSubscribe,GetEvaluateType } from '@api'
const STEPS1  = [
  { text: '选择档案', name: 'Step1' },
  { text: '填写资料', name: 'Step2' },
  { text: '上传证件', name: 'Step3' }
]
const STEPS2  = [
  { text: '填写资料', name: 'Step2' },
  { text: '上传证件', name: 'Step3' }
]
export default {
  name: 'search',
  components: { Step1, Step2, Step3 },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    modify: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      current: 0,
      selection: [],
      params: {},
      fileList: [],
      archivesType: '',
      loading: false
    }
  },
  computed: {
    steps () {
      // 是否是修改资料选择不同的步骤
      return this.modify ? STEPS2 : STEPS1
    },
    componentName () {
      return this.steps[this.current].name
    }
  },
  async created () {
    console.log(await GetEvaluateType())
    const { reload } = this.$route.params
    reload && window.location.reload()
  },
  methods: {
    handleStepChange (index) {
      if (index < this.current) {
        this.current = index
      }
    },
    handGetSelection (selection) {
      this.selection = selection
    },
    handGetParams (params) {
      this.params = params
    },
    handGetFiles (files, type) {
      this.fileList = files
      this.archivesType = type
    },
    async handleSubmit (callback) {
      this.loading = true
      try {
        const query = {
          ...this.params,
          SID: '',
          ArchiveIDS: this.selection.map(({ ID }) => ID).join(','),
          ArchiveQueryType: this.archivesType,
          UploadFiles: this.fileList.filter(({ fileList }) => fileList.length > 0).map(({ type, title, fileList }) => ({
            FileType: type,
            FileContent: title,
            FileName: fileList.map(m => m.response)
          }))
        }
        if (this.modify) {
          // 修改资料模式
          query.SID = this.data.SID
          delete query.ArchiveIDS
        }
        query['SubscribeZQDate'] = formatDate(query['SubscribeZQDate'], 'yyyyMMdd')
        const { data: { Code, Msg,dataValue } } = await PostSubscribe(query)
        if (Code === 0) {
          const onOk = () => {
            callback(dataValue);
            // if (this.$route.name === 'search') {
            //   window.location.reload()
            // } else {
            //   this.$router.push({
            //     path: 'search',
            //     params: { reload: true }
            //   })
            // }
          }
          this.$Modal.success({
            title: '提示',
            content: '登记成功',
            onOk
          })
        } else {
          this.$Message.warning(Msg || '提交失败')
        }
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  position: relative;
}
.steps {
  padding: 16px;
  margin-bottom: 16px;
}
</style>